import { useCallback, useMemo } from 'react';

import { makeSpacesNoBreak } from 'utils/string';

import { useLocale } from '../useSitecoreContext';

/**
 * Format a length in a given unit according to the current locale.
 */
export function useLengthFormatter(unit: 'centimeter' | 'kilometer' | 'meter') {
	const { locale } = useLocale();

	// Available units: https://tc39.es/ecma402/#table-sanctioned-single-unit-identifiers
	const formatter = useMemo(
		() => new Intl.NumberFormat(locale, { style: 'unit', unit }),
		[locale, unit],
	);

	return useCallback(
		(num: number | undefined): string =>
			num === undefined ? '' : makeSpacesNoBreak(formatter.format(num)),
		[formatter],
	);
}
